import React from 'react';
import { observer } from 'mobx-react-lite';
import { SectionTab } from 'polotno/side-panel';
import { Images } from './images';

import * as api from '../api';

export const ProjectsPanel = observer(({ store }) => {
  return (
    <div style={{ height: '100%', overflow: 'auto', paddingRight: '3px' }}>
      <Images
        store={store}
        api={api.ASSETS_API + '?artboardSection=projects'}
      />
    </div>
  );
});

export const ProjectsSection = {
  name: 'projects',
  Tab: (props) => (
    <SectionTab name="Projects" {...props}>
      <img
        src={process.env.PUBLIC_URL + '/icons/projects.svg'}
        alt="Projects"
        style={{ width: '25px' }}
      />
    </SectionTab>
  ),
  Panel: ProjectsPanel,
};
